import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=bc40d3e2&scoped=true&"
import script from "./InvoicesTable.vue?vue&type=script&lang=js&"
export * from "./InvoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc40d3e2",
  null
  
)

export default component.exports